// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/cropperjs/dist/cropper.css
// module id = 1211
// module chunks = 1